(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('BankAccountInfo', BankAccountInfo);

    BankAccountInfo.$inject = ['$resource', 'DateUtils'];

    function BankAccountInfo($resource, DateUtils) {
        var resourceUrl = 'api/bank-account-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
